<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin"></div>
        </Transition>

        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :rowButtonAction="rowButtonAction"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <PrematureForm :formProps="formProps">
                </PrematureForm>
            </template>
            <template #search="searchProps">
                <PrematureSearch :searchProps="searchProps">
                </PrematureSearch>
            </template>
        </v-view>
    </div>

</template>

<script setup>
import { ref } from "vue";
import PrematureForm from './PrematureForm.vue'
import PrematureSearch from './PrematureSearch.vue'
import { rowButtonAction } from '@pages/Helper/crud_utils.js'

const selectedRows = ref([])

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

const isLoading = ref(false)

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
